import ConfirmSecurityQuestionsForm from './ConfirmSecurityQuestionsFormContainer';

export default ConfirmSecurityQuestionsForm;